import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaHome,
  FaShieldAlt,
  FaSearch,
  FaChartLine,
  FaCogs,
  FaSignOutAlt,
  FaChevronRight,
  FaCloud,
  FaNetworkWired,
} from "react-icons/fa";

const MobileMenu = ({ isOpen, toggleMenu, handleLogout }) => {
  const [secureGuardOptions, setSecureGuardOptions] = useState([]);

  const handleSecureGuardClick = () => {
    setSecureGuardOptions((prev) =>
      prev.length === 0
        ? [{ to: "/dashboard/secureguard/compliance", label: "Compliance" }]
        : []
    );
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`mobile-menu-overlay ${isOpen ? "open" : ""}`}
        onClick={toggleMenu}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(170, 172, 242, 0.33)",
          display: isOpen ? "block" : "none",
          zIndex: 1200,
        }}
      ></div>

      {/* Off-Canvas Menu */}
      <div
        className="mobile-menu"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "250px",
          height: "100%",
          backgroundColor: "#342EAD",
          color: "#ecf0f1",
          transform: isOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.3s ease",
          zIndex: 1200,
          overflowY: "auto",
        }}
      >
        {/* Logo */}
        <div
          className="logo text-center"
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#ecf0f1",
            padding: "15px 10px",
          }}
        >
          <span>Logo</span>
        </div>

        {/* Close Button */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        >
          <button
            onClick={toggleMenu}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>

        {/* Navigation Links */}
        <ul className="nav flex-column p-3">
          <li className="nav-item">
            <NavLink to="/dashboard/home" className="nav-link text-white">
              <FaHome />
              <span className="ms-2">Dashboard</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/dashboard/cloudmap" className="nav-link text-white">
              <FaCloud />
              <span className="ms-2">Cloud Map</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/dashboard/cloudmap-diagram" className="nav-link text-white">
              <FaNetworkWired />
              <span className="ms-2">Architecture Diagram</span>
            </NavLink>
          </li>
          {/* Secure Guard with Dropdown */}
          <li className="nav-item dropdown">
            <NavLink
              to="/dashboard/secureguard"
              className="nav-link"
              id="secureguardDropdown"
              role="button"
              onClick={handleSecureGuardClick}
            >
              <FaShieldAlt />
              <span className="me-4 ms-2">Secure Guard</span>
              <div>
                <FaChevronRight
                  style={{
                    transition: "transform 0.3s ease",
                    transform: secureGuardOptions.length > 0 ? "rotate(90deg)" : "rotate(0deg)", // Rotate when dropdown toggled
                  }}
                />
              </div>
            </NavLink>
            {secureGuardOptions.length > 0 && (
              <ul className="nav flex-column mt-1">
                {secureGuardOptions.map((option, index) => (
                  <li key={index} className="nav-item">
                    <NavLink to={option.to} className="nav-link text-white">
                      <FaChevronRight />
                      <span className="ms-2">{option.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li className="nav-item">
            <NavLink
              to="/dashboard/defender-scan"
              className="nav-link text-white"
            >
              <FaSearch />
              <span className="ms-2">Defender Scan</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/dashboard/fineops" className="nav-link text-white">
              <FaChartLine />
              <span className="ms-2">FinOps</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/dashboard/command-center"
              className="nav-link text-white"
            >
              <FaCogs />
              <span className="ms-2">Command Centre</span>
            </NavLink>
          </li>
        </ul>

        {/* Logout Button */}
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <NavLink
            to="#"
            className="nav-link text-white mx-2"
            onClick={handleLogout}
          >
            <FaSignOutAlt />
            <span className="ms-2">Logout</span>
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
